/**
 * @param {string} ISODateString - ISO format Date value in string.
 */

export function dateWithHourFormat(ISODateString) {
  if (!ISODateString) return '-';
  const date = new Date(ISODateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().substring(2, 4);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}